import React, { FC, useRef } from "react"
import "./industryList.scss"
type TItem = { name: string; district: string }
type TTab = {
  list: TItem[]
  idx: number
}
const step = 5

const IndustryList: FC<TTab> = ({ list = [], idx }) => {
  const refList = useRef()
  // const [state, setState] = useSetState({
  //   top: 0,
  //   maxScroll: 0,
  // })
  // const refTimer = useRef<number | never>()
  // const clearTimer = useCallback(() => {
  //   if (refTimer.current) {
  //     console.log("clear", refTimer.current)
  //     refTimer.current = null
  //     clearTimeout(refTimer.current)
  //   }
  // }, [refTimer])
  // useMemo(() => {
  //   let { top, maxScroll } = state
  //   return
  //   refTimer.current && clearTimeout(refTimer.current)
  //   refTimer.current = window.setTimeout(() => {
  //     let nxt = top === maxScroll ? 0 : Math.min(maxScroll, top + step)
  //     setState({ top: nxt })
  //   }, 40)
  // }, [state.top, state.maxScroll, refTimer])

  // useEffect(() => {
  //   let $list: HTMLElement = refList.current
  //   if ($list) {
  //     let parent: HTMLElement = $list.parentNode as HTMLElement
  //     let pHeight = parent.offsetHeight
  //     let height = $list.offsetHeight
  //     let maxScroll = height //- pHeight
  //     // setState({ top: 0, maxScroll })
  //     // // clearTimer()
  //     // setTop(0)
  //     // if (maxScroll > 0) {
  //     //   // clearTimeout(refTimer.current)
  //     //   console.log("start myAnimate", maxScroll)
  //     //   if (refTimer.current) {
  //     //     console.log("refTimer.current", refTimer.current)
  //     //     return
  //     //   } else {
  //     //     myAnimate(maxScroll, 0)
  //     //   }
  //     // }
  //     // return () => {
  //     //   clearTimer()
  //     //   // clearTimeout(refTimer.current)
  //     // }
  //   }
  // }, [refList, list, clearTimer])
  // useEffect(() => {
  //   return () => {
  //     clearTimer()
  //   }
  // }, [clearTimer])

  return (
    <div className="ls-industry">
      <div className={"scroll-wrap scroll-" + (idx + 1)} ref={refList}>
        {list.map((item, i) => {
          return (
            <div className="it-ind" key={i}>
              <span className="name">{item.name}</span>
              <span className="dis">{item.district}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default IndustryList
